module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5gFmx"))).then(() => parcelRequire('d0iPb'));